export default __webpack_public_path__ + "static/Idea@2x-b891a05966141ed377090fbef3a20cc9.png";